import React from 'react';
import { Info, Star } from 'lucide-react';
import { PRODUCT_ICONS } from '../pages/admin/linksConfig.utils';

export const ProductTileIcon = ({ id }) => {
  const Icon = PRODUCT_ICONS[id] || Star;
  return <Icon size={21} strokeWidth={2.35} />;
};

export const InfoTip = ({ text }) => (
  <span className="fsl-infotip" tabIndex={0} role="button" aria-label={text}>
    <Info size={14} strokeWidth={2.4} />
    <span className="fsl-infotip-bubble" role="tooltip">{text}</span>
  </span>
);

export const Toggle = ({ checked, onChange, label, disabled = false }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    className={`fsl-toggle ${checked ? 'is-on' : ''}`}
    onClick={disabled ? undefined : onChange}
    disabled={disabled}
  >
    <span className="fsl-toggle-knob" />
  </button>
);
